/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerJoinComponent', [
    '$timeout',
    'DesignerComponent',
    'DesignerSchema',

    function ($timeout, DesignerComponent, DesignerSchema) {
      function DesignerJoinComponent() {
        DesignerComponent.apply(this);

        this.join_type = null;
        this.optimization_type = null;
        this.relations = [];
      }

      DesignerJoinComponent.prototype = new DesignerComponent();

      DesignerJoinComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          join_type: this.join_type || this.defaults.join_type,
          optimization_type: this.optimization_type || this.defaults.optimization_type,
          relations: this.relations || this.defaults.relations,
        });

        return data;
      };

      DesignerJoinComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerJoinComponent.prototype.setData = function (data) {
        this.join_type = data.join_type;
        this.optimization_type = data.optimization_type;
        this.relations = data.relations;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerJoinComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();

        schema.id = this.id;
        schema.name = this.name;

        if (this.inputEdges.length >= 2) {
          const firstInput = _.find(this.inputEdges, { order: 0 });
          const secondInput = _.find(this.inputEdges, { order: 1 });

          if (!firstInput || !secondInput) {
            return schema;
          }

          const firstSchema = firstInput.sourceComponent.getSchema();
          const secondSchema = secondInput.sourceComponent.getSchema();

          const intersection = _.intersection(_.map(firstSchema.fields, 'name'), _.map(secondSchema.fields, 'name'));
          if (intersection.length) {
            _.each(intersection, function (fieldName) {
              _.find(firstSchema.fields, { name: fieldName }).name = `${firstSchema.name}::${fieldName}`;
              _.find(secondSchema.fields, { name: fieldName }).name = `${secondSchema.name}::${fieldName}`;
            });
          }

          schema.fields = _(schema.fields).concat(firstSchema.fields).concat(secondSchema.fields).value();
        }

        return schema;
      };

      return DesignerJoinComponent;
    },
  ]);
})(window.angular);
